import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { RowEventEmit } from "../../admin/events-screen/event-page-models/row-event-emit";

@Component({
  selector: "generic-action-menu",
  templateUrl: "./generic-action-menu.component.html",
  styleUrls: ["./generic-action-menu.component.scss"],
  animations: [
    trigger("transformMenu", [
      state(
        "void",
        style({
          opacity: 0,
          transform: "scale(0.8)",
        })
      ),
      transition(
        "void => enter",
        animate(
          "120ms cubic-bezier(0, 0, 0.2, 1)",
          style({
            opacity: 1,
            transform: "scale(1)",
          })
        )
      ),
      transition(
        "* => void",
        animate("100ms 25ms linear", style({ opacity: 0 }))
      ),
    ]), //
  ],
})
export class GenericActionMenuComponent {
  @ViewChild("componentMain") public componentMain: ElementRef;
  @Output("menu-event") public rowEvent: EventEmitter<RowEventEmit> =
    new EventEmitter<RowEventEmit>();
  public menuActions: Array<{
    action: string;
    text: string;
    customIcon?: string;
  }> = [
    { action: "edit", text: "עריכה" },
    { action: "delete", text: "מחיקה" },
    { action: "duplicate", text: "שכפול" },
  ];
  public menuIsOpen: boolean = false;
  @Input("menuStyle") public menuStyle:
    | "tree-dots"
    | "tree-dots-wide"
    | "tree-dots-wide-right"
    | "down-arrow"
    | "down-arrow-michlol-screen" = "tree-dots";
  @Input("customActions") public set customActions(
    value: Array<{ action: string; text: string; customIcon?: string }>
  ) {
    this.menuActions = value;
  }

  public clickedAction(
    $event: MouseEvent,
    action:
      | "edit"
      | "delete"
      | "duplicate"
      | "makeActive"
      | "makeInactive"
      | string
  ) {
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    // tslint:disable-next-line:no-object-literal-type-assertion
    const menuEvent: RowEventEmit = {
      action,
      eventId: "0",
      eventObject: null,
    } as RowEventEmit;
    this.rowEvent.emit(menuEvent);
    this.closeMenu();
  }

  public openMenu($event) {
    $event.stopPropagation();
    $event.stopImmediatePropagation();

    this.menuIsOpen = !this.menuIsOpen;
    setTimeout(() => {
      // this will make the execution after the above boolean has changed
      this.componentMain.nativeElement.focus();
    }, 10);
  }

  public closeMenu() {
    this.menuIsOpen = false;
  }
  public getCustomIconUrl(customIcon: string) {
    switch (customIcon) {
      case "editActivityFields":
        return "edit-activity-field.svg";
      case "trashBin":
        return "trash-bin.svg";
      case "editUserProfile":
        return "edit-user-profile.svg";
      case "resetPassword":
        return "reset-password.svg";
      case "setActive":
        return "is-active-black.svg";
      case "setInActive":
        return "is-not-active-black.svg";
      case "viewReceipt":
        return "bank-deposit-black.svg";
      case "bankDeposit":
        return "view-receipt.svg";
    }
  }
  public getIcon(action: { action: string; text: string }) {
    switch (action.action) {
      case "edit":
        return "fa-pencil";
      case "delete":
        return "fa-trash";
      case "duplicate":
        return "fa-copy";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/form/generic-action-menu/generic-action-menu.component.ts